import { css } from 'linaria';

export const card = css`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;
`;

export const card__image__container = css`
  position: relative;
  width: 100%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const card__image = css`
  width: 100%;
  height: 100%;
  max-width: 100%;
  position: absolute;
  object-fit: cover;
  background: var(--background-secondary);
`;

export const card__image_large = css``;

export const card__caption = css`
  padding: var(--space-100) 0;
  display: flex;
  flex-direction: column;
`;

export const card__price = css`
  display: flex;
`;

export const card__projectName = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;
